import getChildrenSelectedCategories from './getChildrenSelectedCategories'
import { getNumberOfChildrenTreatedAsAdults } from './getNumberOfChildrenTreatedAsAdults'
import { getNumberOfChildrenWithPercentageValues } from './getNumberOfChildrenWithPercentageValues'
import getOBPChildrenPrice from './getOBPChildrenPrice'
import getPaxForPersons from './getPaxForPersons'
import getAllAdultsRate, { capChildrenPrice } from './getAllAdultsRate'

/**
 * I do realize this is utterly confusing. Idea is as follows
 * 1. Take adults + all children as min occupancy row
 * 2. Take all custom percentage - and add them to total persons
 * 3. Take average of totalPersons pax row minus minOccupancy row on calendar and use that as base for all % calculations
 * 4. On top of everything add all custom nominal & manually entered values
 * 5. Trim the children charge so the stay never costs more than the same headcount of adults
 */
const getTotalOBPRate = (ratePlan, adults, childrenAges, unitTypeOccupancy) => {
  const { childrenCategories } = ratePlan
  let adultsNumber = adults || 0
  const childrenSelectedCategories = getChildrenSelectedCategories(childrenAges, childrenCategories)
  // because value type nominal for children we are not counting inside pax, we are adding it separately
  const numberOfChildrenTreatedAsAdults = getNumberOfChildrenTreatedAsAdults(childrenSelectedCategories)
  adultsNumber += numberOfChildrenTreatedAsAdults

  const persons = adultsNumber + getNumberOfChildrenWithPercentageValues(childrenSelectedCategories)

  const paxPriceForAllPersons = getPaxForPersons(ratePlan, persons)?.totalRate || 0
  const paxPriceForAdults = getPaxForPersons(ratePlan, adultsNumber)?.totalRate || 0

  const childrenPrice = getOBPChildrenPrice(
    childrenSelectedCategories,
    (paxPriceForAllPersons - paxPriceForAdults) / (persons - adultsNumber),
    ratePlan.nights
  )

  const allAdultsRate = getAllAdultsRate(ratePlan, unitTypeOccupancy, adults, childrenAges)

  return paxPriceForAdults + capChildrenPrice(childrenPrice, paxPriceForAdults, allAdultsRate)
}

export default getTotalOBPRate
